module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00030-fs8.ed38327.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00030-fs8.png
// module id = 183
// module chunks = 0